import { z } from "zod";

import type { CreditAmount } from "@/features/referral/models";
import type { Price } from "@/shared/domains";
import { parseResponseData, privateAPI } from "@/shared/lib";
import type { Product } from "../models";
import {
  categoryWithProductsSchema,
  productSchema,
  summarySchema,
} from "../models";

const getCategoriesWithProductsResponseSchema = z.object({
  categories: z.array(categoryWithProductsSchema),
});

export const getCategoriesWithProducts = async () => {
  const response = await privateAPI.get(`shop/categories-and-products`);

  return parseResponseData(response, getCategoriesWithProductsResponseSchema)
    .categories;
};

export const getProductsDiscount = async (id: Product["id"]) => {
  const response = await privateAPI.get(`patients/products/${id}/discounts`);

  return parseResponseData(response, productSchema);
};

export interface GetSummaryParams {
  priceId: Price["id"];
  creditAmount?: CreditAmount;
}

export const getSummary = async ({
  priceId,
  creditAmount,
}: GetSummaryParams) => {
  const response = await privateAPI.get(`shop/${priceId}/summary`, {
    params: { creditAmount },
  });

  return parseResponseData(response, summarySchema);
};
